import { Container } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import UserShopProfile from "../../components/UserShopProfile/UserShopProfile";
import CompanyJobList from "./components/jobList";
import BackArrow from "../../components/backArrow";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useState, useEffect } from "react";
import {
  useGetCompanyByIdQuery,
  useCreateHelpMutation,
  useGetJobsByCompanyQuery,
} from "../../features/user/userApiSlice";
import { extractIdFromSlug } from "../../utils/slugUtils";
const FindjobOnline = () => {
  const { id: slugId } = useParams();
  const id = extractIdFromSlug(slugId);
  const navigate = useNavigate();
  const imageUrl = useSelector((state) => state.imgurl);
  const { name } = useSelector((state) => state.user);
  const itemData = useSelector((state) => state.itemdata);
  const [lgShowreport, setLgShowreport] = useState(false);
  
  const [createShop, setCreateShop] = useState({
    userid: name._id,
    problem: "",
    desciription: "",
    image: [""],
  });

  const { data: shopRes } = useGetCompanyByIdQuery(id, { skip: !id });
  const shopData = shopRes?.data?.Company;

  const { data: companyJobsRes, isLoading: isCompanyJobsLoading } =
    useGetJobsByCompanyQuery(id, { skip: !id });
  const companyJobs = companyJobsRes?.data?.Jobs || [];

  const [createHelp, { isLoading: isHelpLoading }] = useCreateHelpMutation();
  useEffect(() => {
    setCreateShop((createShop) => ({
      ...createShop,
      image: imageUrl?.imgurl || "",
    }));
  }, [imageUrl]);

  const PostShopDatas = async (e) => {
    e.preventDefault();
    try {
      const response = await createHelp(createShop).unwrap();
      if (response?.success) {
        setLgShowreport(false);
        setTimeout(() => {
          SuccessNotify("Form Retailer Shop Created Successfully");
          navigate(`/retailer-userprofile/${slugId}`);
        }, 1000);
      }
    } catch (error) {
      FailedNotify("Failed To Create Shop");
    }
  };

  return (
    <Container>
      <Row>
        <Col md={4} lg={4} className="screenHeight">
          <BackArrow back="/find-job" mystyle="ps-2 pt-1 d-lg-none" />
          <div className="border b-radius height_100">
            <UserShopProfile
              PostShopDatas={PostShopDatas}
              setCreateShop={setCreateShop}
              lgShowreport={lgShowreport}
              setLgShowreport={setLgShowreport}
              shopData={shopData}
              shopid={id}
              id={slugId}
            />
          </div>
        </Col>
        <Col md={8} lg={8} className="screenHeight">
          <BackArrow back="/find-job" mystyle="d-none d-lg-block" />
          <div className="border b-radius px-3 ">
            <CompanyJobList
              itemData={itemData}
              companyJobs={companyJobs}
              companyJobsLoading={isCompanyJobsLoading}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default FindjobOnline;
